import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { ComunicadosService } from "src/app/services/comunicados.service";
import { listarComunicados, listarComunicadosFailure, listarComunicadosSuccess } from "../actions/listar-comunicados.action";

@Injectable()
export class ListarComunicadosEffects {

  public listarComunicados$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly comunicadosService: ComunicadosService) {
    this.createEffects()
  }

  private createEffects() {
    this.listarComunicados$ = createEffect(() => this.actions$.pipe(
      ofType(listarComunicados),
      switchMap(({ listarComunicadosInputDto }) =>
        this.comunicadosService
          .listarComunicados(listarComunicadosInputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return listarComunicadosFailure({ response })
              }
              return listarComunicadosSuccess({ response })
            }),
            catchError(() => {
              return of()}
            )
          )
      )
    )
    );
  }
}